import { IPagination, IProduct } from "@Interfaces/Api/Product";
import {
  Box,
  Container,
  Grid,
  Icon,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  StyledGrayButton,
  StyledGreenButton,
  StyledLightGreenButton,
} from "@Styled/Common";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import CategoryFilter from "./CategoryFilter";
import { CartActions } from "@Redux-Store/Actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import { SetStateAction, useContext, useEffect, useState } from "react";
import { apiProduct } from "@Services/API/IndividualApi's/Products";
import router, { useRouter } from "next/router";
import CategoryProducts from "@Components/Pages/Landing/CategorySection/Categories/Category/Products/CategoryProducts";
import HeroBanner from "@Components/Pages/Landing/HeroBanner";
import {
  StyledCategoryFilterContainer,
  StyledEmptyContainer,
} from "@Styled/Pages/Category";
import { theme } from "@Definitions/Styled";
import InfiniteScroller from "@Components/Pages/Common/InfiniteScroller";
import Spinner from "@Components/Pages/Common/Spinner";
import { ICategory } from "@Interfaces/Api/category";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import { IBannerContent } from "@Interfaces/Api/cms/Banner";
import { BannerContext } from "@Pages/index";

export interface ICategoryProps {
  categories: ICategory;
}

const CollectionsPage = ({ categories }: ICategoryProps) => {
  const [product, setProduct] = useState<IProduct[]>([]);
  const [pagination, setPagination] = useState<IPagination>();
  const [perPage, setPerPage] = useState<number>(3);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [productId, setProductId] = useState<string>("");
  const [filteredCategory, setFilteredCategory] = useState<any>([]);
  const dispatch = useDispatch();
  const { query } = useRouter();

  useEffect(() => {
    setPage(1);
    setProduct([]);
    getProduct(1);
    if (categories) {
      setLoading(false);
    }
  }, [categories, query.childCategory, filteredCategory]);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const cartData = useSelector((state) => state?.CartReducer?.cart);

  const sortedProducts = product.slice().sort((a, b) => {
    if (a.inStock === b.inStock) return 0;
    return a.inStock ? -1 : 1;
  });

  useEffect(() => {
    if (page > 1) {
      getProduct(page);
    }
  }, [page]);

  const loadMoreProduct = async () => {
    setPage(page + 1);
  };

  const getProduct = async (page: number | undefined) => {
    let slug: string;
    let obj = {};
    try {
      if (filteredCategory?.length > 0) {
        slug = filteredCategory as string;
        obj = {
          $and: [
            {
              categories: {
                $in: slug,
              },
            },
          ],
        };
      } else {
        if (query.childCategory) {
          slug = `${categories.category}` as string;
        } else {
          slug = categories.category as string;
        }
        obj = {
          $and: [
            {
              categories: {
                $eq: slug,
              },
            },
          ],
        };
      }

      const queryParam = `&filter=${JSON.stringify(obj)}`;
      const response = await apiProduct.getAll!(page, perPage, queryParam);
      // setLoading(false);
      setPagination(response.pagination);
      setProduct((prevVal) => [...prevVal, ...response.data]);
    } catch (err) {
      console.log(err);
    }
  };
  const spinner = useSelector((state) => state?.CartReducer.loader);

  const handleAddToCart = async (productId: string) => {
    const cart = {
      productId: productId,
      quantity: 1,
    };
    dispatch(CartActions.AddToCart(cart));
  };

  const handleViewCart = () => {
    router.push("/myCart");
  };
  const handleFilteredPoucts = async (items: string) => {
    setPage(1);
    setProduct([]);
    setFilteredCategory(items);
  };

  const getAllProducts = (item: SetStateAction<string | undefined>) => {
    setFilteredCategory(item);
    setPage(1);
  };
  const allBanners = useContext<IBannerContent[]>(BannerContext) || [];

  return (
    <>
      <Box sx={{ marginBottom: "2rem" }}>
        {/* {loading && (
          <Loader
            style={{ flexWrap: "wrap", dispaly: "flex" }}
            renderSkeleton={CategoryPageSkeleton}
          />
        )} */}
        <HeroBanner homePage={false} allBanners={allBanners} />
        <Container
          sx={{
            marginTop: { sm: "4rem", xs: "1rem" },
            marginBottom: "5rem",
            padding: "0px 0px",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{ padding: { sm: "0px 15px", xs: "0rem 0.5rem 0px 0px" } }}
            >
              <Box sx={{ padding: { sm: "2px 15px", xs: "5px" } }}>
                {!query.childCategory ? (
                  <CategoryFilter
                    handleFilteredPoucts={handleFilteredPoucts}
                    getAllProducts={getAllProducts}
                  />
                ) : (
                  <StyledCategoryFilterContainer>
                    <StyledHeadingWithGradientunderline
                      variant="h1"
                      sx={{
                        fontSize: { sm: "1.5rem", xs: "1.2rem" },
                        letterSpacing: "-1px",
                      }}
                    >
                      {query.category}/{query.childCategory}
                    </StyledHeadingWithGradientunderline>
                  </StyledCategoryFilterContainer>
                )}
              </Box>
            </Grid>
          </Grid>
          <InfiniteScroller
            fetchMoreData={loadMoreProduct}
            hasMore={pagination?.hasNext || false}
            dataLength={product.length}
          >
            <Grid container>
              {sortedProducts.map((product) => {
                const idx = cartData?.cartItems.findIndex((item) => {
                  return item.product._id == product._id;
                });
                return (
                  <Grid
                    item
                    sm={4}
                    xs={6}
                    key={product._id}
                    sx={{
                      padding: { sm: "15px", xs: ".5rem 0.5rem 0px 0px" },
                    }}
                  >
                    <Box
                      sx={{
                        padding: { sm: "15px", xs: "5px" },
                        height: "100%",
                        margin: { sm: "0px", xs: "0px 0px 5px 0px" },
                      }}
                    >
                      <CategoryProducts product={product} homePage={false} />
                      <Box>
                        {product.inStock ? (
                          <>
                            {idx == -1 || idx == undefined ? (
                              <StyledLightGreenButton
                                onClick={() => {
                                  setProductId(product._id);
                                  {
                                    handleAddToCart(product._id!);
                                  }
                                }}
                                sx={{
                                  marginTop: "5px",
                                  fontSize: {
                                    sm: "1.1rem",
                                    xs: "0.8rem",
                                  },
                                  padding: {
                                    md: "0.5rem 1rem",
                                    xs: "0.5rem 0.2rem",
                                  },

                                  width: "100%",
                                }}
                              >
                                {spinner && productId == product._id ? (
                                  <Spinner
                                    spinColor={theme.palette.primary.main}
                                  />
                                ) : (
                                  ""
                                )}
                                Add To Cart
                                <Icon
                                  sx={{
                                    fontSize: {
                                      sm: "1.5rem",
                                      xs: "1rem",
                                    },
                                  }}
                                  component={ShoppingCartCheckoutIcon}
                                />
                              </StyledLightGreenButton>
                            ) : (
                              <StyledGreenButton
                                onClick={() => {
                                  handleViewCart();
                                }}
                                sx={{
                                  marginTop: "5px",
                                  fontSize: {
                                    sm: "1.1rem",
                                    xs: "0.8rem",
                                  },
                                  padding: {
                                    md: "0.5rem 1rem",
                                    xs: "0.5rem 0.2rem",
                                  },

                                  width: "100%",
                                }}
                              >
                                {spinner && productId == product._id ? (
                                  <Spinner
                                    spinColor={theme.palette.neutral.main}
                                  />
                                ) : (
                                  ""
                                )}
                                View Cart
                                <Icon
                                  sx={{
                                    fontSize: {
                                      sm: "1.5rem",
                                      xs: "1rem",
                                    },
                                  }}
                                  component={ShoppingCartCheckoutIcon}
                                />
                              </StyledGreenButton>
                            )}
                          </>
                        ) : (
                          <StyledGrayButton
                            sx={{
                              marginTop: "5px",
                              color: "red",
                              background: theme.palette.secondary.main,
                              fontSize: { sm: "1.1rem", xs: "0.8rem" },
                              padding: {
                                md: "0.5rem 1rem",
                                xs: "0.5rem 0.2rem",
                              },
                              width: "100%",
                            }}
                          >
                            OUT OF STOCK
                          </StyledGrayButton>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </InfiniteScroller>
          {
            <>
              {!loading && product.length == 0 && (
                <Container
                  component={Paper}
                  sx={{
                    alignSelf: "center",
                    marginBottom: "5rem",
                    marginTop: "2rem",
                  }}
                >
                  <StyledEmptyContainer>
                    <Typography variant="subtitle1">No Products</Typography>
                  </StyledEmptyContainer>
                </Container>
              )}
            </>
          }
        </Container>
      </Box>
    </>
  );
};
export default CollectionsPage;
